import React, { FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const BlinkingDots: FC<Props> = ({ children }) => {
  return (
    <div className="chatBox__dialog--indicator blinking-dots">
      {children}
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
    </div>
  )
}

export default BlinkingDots
